module.exports = __webpack_public_path__ + "static/LTCCard-c0a4f9de690398d1a72eebc319666c69.png";